import React from 'react';
import PropTypes from 'prop-types';
import {times} from 'lodash';
import Icon from 'shared/components/icon';

export default class StepProgress extends React.Component {
  static propTypes = {
    itemsTotal: PropTypes.number.isRequired,
    itemsComplete: PropTypes.number.isRequired,
    iconIndex: PropTypes.number,
  };

  renderStepProgress = () => {
    const {itemsTotal, itemsComplete, iconIndex} = this.props;

    // Show progress either by which step
    // or by itemsComplete
    const checkIndex = iconIndex ? iconIndex : itemsComplete;

    return times(itemsTotal, (index) => (
      <li key={index} className={index >= itemsComplete ? 'incomplete' : 'complete'}>
        {index === itemsTotal - 1 ? <Icon iconType="trophy" /> : null}
        {index < itemsTotal - 1 && index === checkIndex - 1 ? <Icon iconType="check" /> : null}
      </li>
    ));
  };

  render() {
    return <ul className="shared-step-progress">{this.renderStepProgress()}</ul>;
  }
}
